export default {
  testPageTitle: 'tests.createPageTitle',
  editPageTitle: 'tests.editPageTitle',
  numberOfIndexesError: 'ra.validation.numberOfIndexes',
  estimatedSamplingTimeParseFail:
    'ra.validation.estimatedSamplingTimeParseFail',
  unknownError: 'ra.page.error',
  duplicationError: 'ra.validation.duplicationError',
};
